import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import parse from 'html-react-parser';
import * as MedlemsAdfaerdService from '@Utils/medlemsAdfaerdService';
import Form from '../Form';
import { TInput, TModal } from '../../utils/types';
import SsoPensionsinfo from '@Components/ssoPensionsinfo';
import { useGlobalState } from '@Store/auth.store';
import Modal from '../Modal';
import ButtonContainer from '../ButtonContainer';

interface ConsentModalProps {
  objdata?: {[name: string]: string}
  modalData: TModal
  consent?: boolean
  showConsent: boolean
  showPensionInfo?: boolean
  inputData?: TInput
  showEmailonlyForm: boolean
  samtykkeTekst?: string
  samtykkeLabel?: string
  baseInteraktionDialogId?: string
  velkomstEpiserverId?: string
  handleModalVisibility: () => void
  setInputData?: (inputData: TInput) => void
  setFormSubmitted?: (submitted: boolean) => void
  setShowForm?: (showForm: boolean) => void
  setShowModal: (showModal: boolean) => void
  setShowReceipt?: (showReceipt: boolean) => void
  setShowSalaryContent?: (showSalaryContent: boolean) => void
  setConsentFromModal?: (consentFromModal: boolean) => void
}

const ConsentModal = (props: ConsentModalProps) => {
	const history = useHistory();
	const { chapterId } = useParams<{chapterId: string}>();
	const {
		objdata,
		modalData,
		showConsent,
		samtykkeTekst,
		samtykkeLabel,
		showEmailonlyForm,
		inputData,
		velkomstEpiserverId,
		handleModalVisibility,
		setFormSubmitted,
		setInputData,
		setShowForm,
		setShowModal,
		setShowReceipt,
		setShowSalaryContent,
		setConsentFromModal
	} = props;

	const { modalHeader, modalText, modalBtnText1, modalBtnLink1, modalBtnText2, salaryContent, pensionInfo, raadBtn, raadMail } = modalData;
	const [isPenstionsinfoLoggedin] = useGlobalState('isPenstionsinfoLoggedin');
	const currentBlock = {
		pensionsinfoKnapLabel: modalBtnText1,
		pensionsinfoTekst: null,
		pensionsinfoFejlTekst: 'FEJL I PENSIONSTJEK KALD',
		sendTilRaadgivningKnapTekst: raadBtn,
		sendTilRaadgivningEmail: raadMail
	};

	const handleClick = () => {
		if (setShowForm) {
			if (objdata && !salaryContent) {
				MedlemsAdfaerdService.gemInteraktion('KontaktoplysningerSpringOver', objdata['BaseInteraktionDialogId'], '', 'WEB');
			}
			setShowForm(false);
		}

		if (setShowReceipt) {
			setShowReceipt(true);
		}
		handleModalVisibility();

		if (salaryContent && setShowSalaryContent) {
			setShowSalaryContent(false);

			if (objdata) {
				MedlemsAdfaerdService.gemInteraktion('LønSpringOver', objdata['BaseInteraktionDialogId'], '', 'WEB');
			}
		}
	};

	useEffect(() => {
		if (showConsent && setConsentFromModal) {
			setConsentFromModal(true);
		}
	}, []);

	useEffect(() => {
		if (pensionInfo && isPenstionsinfoLoggedin) {
			history.push(`${chapterId}/snack/1`);
		}
	}, [isPenstionsinfoLoggedin]);

	return (
		<Modal
			onClose={ () => {
				handleModalVisibility();

				if (showConsent && !showEmailonlyForm) {
					MedlemsAdfaerdService.gemInteraktion('SamtykkeLuk', objdata['BaseInteraktionDialogId'], '', 'WEB');
				}
			} }
			width={ !showEmailonlyForm && showConsent ? 'medium' : 'small' }
			customStyle={ { paddingBottom: '3.75rem' } }
		>
			{ !showConsent && !showEmailonlyForm && (
				<>
					<Modal.Content customStyle={ { marginTop: '0' } }>
						{ modalHeader && <h2 className="f36">{ modalHeader }</h2> }
						{ modalText && <span className="f18">{ parse(modalText) }</span> }
					</Modal.Content >
					<ButtonContainer m_modal>
						{ pensionInfo && <SsoPensionsinfo classBlock={ 'nyipka' } currentBlock={ currentBlock } linkTilPensionsInfo={ modalBtnLink1 } /> }
						{ modalBtnText1 && !pensionInfo && <button className="btn" onClick={ () => handleModalVisibility() }>{ modalBtnText1 }</button> }
						{ modalBtnText2 && <button className="btn btn-secondary" onClick={ handleClick }>{ modalBtnText2 }</button> }
					</ButtonContainer>
				</>
			) }
			{ showConsent && !showEmailonlyForm && (
				<Modal.ConsentContainer>
					<Modal.Content>
						{ samtykkeTekst && parse(samtykkeTekst) }
					</Modal.Content>
					<Form
						introButtonText={ 'Gem' }
						baseInteraktionDialogId={ objdata ? objdata['BaseInteraktionDialogId'] : undefined }
						inputData={ inputData ? inputData : {} }
						showEmail={ true }
						showPhn={ true }
						showSalary={ false }
						showDataPolicy={ false }
						samtykkeLabel={ samtykkeLabel }
						showConsent={ true }
						velkomstEpiserverId={ velkomstEpiserverId ? velkomstEpiserverId : '' }
						objdata={ objdata }
						setShowModal={ setShowModal }
						setInputData={ setInputData ? setInputData : () => {
							return;
						} }
						setFormSubmitted={ setFormSubmitted ? setFormSubmitted : () => {
							handleClick();
						} }
						setShowSalaryReceipt={ setFormSubmitted ? setFormSubmitted : () => {
							return;
						} }
					/>
				</Modal.ConsentContainer>
			) }
			{ showEmailonlyForm && (
				<Modal.Content>
					{ modalHeader && <h2 className="f36">{ modalHeader }</h2> }
					{ modalText && <span className="f18">{ parse(modalText) }</span> }
					<Form
						introButtonText={ 'Gem' }
						inputData={ inputData ? inputData : {} }
						showConsent={ false }
						showEmail={ true }
						showPhn={ false }
						showSalary={ false }
						showDataPolicy={ true }
						objdata={ objdata }
						persondataLabel={ objdata ? objdata['PersondataLabel'] : undefined }
						velkomstEpiserverId={ velkomstEpiserverId ? velkomstEpiserverId : '' }
						setShowModal={ setShowModal }
						setInputData={ setInputData ? setInputData : () => {
							return;
						} }
						setFormSubmitted={ setFormSubmitted ? setFormSubmitted : () => {
							return;
						} }
						setShowSalaryReceipt={ setFormSubmitted ? setFormSubmitted : () => {
							return;
						} }
					/>
				</Modal.Content>
			) }
		</Modal>
	);
};

export default ConsentModal;